export default function() {
    if (!Element.prototype.closest) {
        var matchesFn;

        ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector']
            .some(function(fn) {
                if (typeof document.body[fn] == 'function') {
                    matchesFn = fn;
                    return true;
                }
                return false;
            });

        Element.prototype.closest = function (selector) {
            var el = this;
            var parent;

            while (el) {
                parent = el.parentElement;
                if (parent && parent[matchesFn](selector)) {
                    return parent;
                }
                el = parent;
            }
            return null;
        };
    }
}


// WEBPACK FOOTER //
// ./uPortal/Content/js/Polyfill/closest.js